export default __webpack_public_path__ + "static/backgroundHomeTV-5ac7e36532e48ff0cb80666fbb882ffd.png";